import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { telemetry } from '@/lib/telemetry';
import { useAuthenticatedSession } from '@/authenticatedSession/AuthenticatedSessionContext';

// Borrowed from https://stackoverflow.com/a/75911707/176304
const ScreenViewReporter = () => {
  const location = useLocation();
  const authSession = useAuthenticatedSession();

  // Use a ref so route-change events pick up the latest auth state
  // without re-firing when auth resolves on the same page.
  const authSessionRef = useRef(authSession);
  authSessionRef.current = authSession;

  useEffect(() => {
    const session = authSessionRef.current;
    telemetry.analyticsEvent({
      name: 'screen_view',
      extra: {
        firebase_screen: location.pathname,
        ...(session && {
          tenantId: session.tenantId,
          authUserId: session.userIds.auth,
        }),
      },
    });
  }, [location]);

  return null;
};

export default ScreenViewReporter;
